<div class="wrapper">
	<binary-question [htmlIdPrefix]="binaryQuestionHtmlID" [formKey]="formKey" [form]="form" [question]="question.question" [formService]="formService" [formGroup]="form"
					 [controlName]="binaryQuestionControlName" [dataTestId]="'binary-question-' + question.type + '-' + formKey"></binary-question>

	<div class="flex-gap"></div>

	@if (textAreaVisible) {
		<text-area [htmlPrefix]="textAreaHtmlID" [formKey]="formKey" [form]="form" [formService]="formService" [autoGrowEnabled]="autoGrowEnabled"
				   [controlName]="textAreaControlName" [placeholder]="textAreaPlaceHolder | translate" [dataTestId]="'binary-additional-question-' + question.type + '-' + formKey">
		</text-area>
	}
</div>
